import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useImagesSection} from '../useGetProductBulkSection';
import {
  ProductImageDetailsModalView,
  ProductImageDetailsModalViewProps,
} from './ProductImageDetailsModalView';

export const ProductImageDetailsModal: React.FC<
  ProductImageDetailsModalViewProps
> = props => {
  return (
    <DataFetcher
      request={useImagesSection()}
      Error={() => null}
      viewProps={props}
      View={ProductImageDetailsModalView}
    />
  );
};
